import React from 'react';
import cx from 'classnames';
export const NoData = ({ title, text, bordered = true }) => {
    return (React.createElement("div", { className: cx('grid-no-data', { 'grid-no-data--bordered': bordered }) },
        React.createElement("span", { className: "no-search-data-image" }),
        React.createElement("h1", { className: "grid-no-data-title mosaic--type-gamma" }, title),
        React.createElement("p", { className: "grid-no-data-text mosaic--type-zeta" }, text)));
};
//# sourceMappingURL=NoData.js.map